import React from "react";
import Page from "../components/Page";
import {
  Accordion,
  AccordionSummary,
  Card,
  Container,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import { Link } from "react-router-dom";
const Catalogos = () => {
  return (
    <>
      <Page title="Catálogos del Sistema">
        <Container maxWidth="xl">
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            mb={5}
          >
            <Typography variant="h4" gutterBottom>
              Catálogos del Sistema
            </Typography>
          </Stack>
          <Grid item xs={12} md={12} lg={12}>
            <Link to="cbancarrios">
              <Accordion>
                <AccordionSummary
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography>Conceptos Bancarios</Typography>
                </AccordionSummary>
              </Accordion>
            </Link>

            <Accordion>
              <AccordionSummary>
                <Link to="conceptosegreso">
                  <Typography>Catálogo de Egresos</Typography>
                </Link>
              </AccordionSummary>
            </Accordion>
            <Accordion>
              <AccordionSummary>
                <Link to="subcuentas">
                  <Typography>Catálogo de Subcuentas de Egresos</Typography>
                </Link>
              </AccordionSummary>
            </Accordion>
          </Grid>
        </Container>
      </Page>
    </>
  );
};

export default Catalogos;
